import { IScope } from "angular";
import { IRole, RoleService } from "@gtmhub/roles";
import { StateService } from "@uirouter/angularjs";
import { IntegrationService } from "@gtmhub/integrations/services";

export interface IRoleMappingScope extends IScope {
  indicators;
  roles: IRole[];
  mappings: any;
  existingMappings: any;
  addMapping(): void;
  removeMapping(index: number): void;
  deleteMapping(index: number): void;
  saveMappings(): void;
}

export class RoleMappingCtrl {
  public static $inject = ["$scope", "$state", "RoleService", "IntegrationService"];

  constructor(private $scope: IRoleMappingScope, private $state: StateService, private roleService: RoleService, private integrationService: IntegrationService) {
    this.$scope.addMapping = this.addMapping;
    this.$scope.removeMapping = this.removeMapping;
    this.$scope.deleteMapping = this.deleteMapping;
    this.$scope.mappings = [];
    this.$scope.existingMappings = [];
    this.$scope.indicators = {};
    this.$scope.saveMappings = this.saveMappings;
    this.loadRoles();
    this.loadMappings();
  }

  private loadMappings = () => {
    this.$scope.indicators.mappings = true;
    this.integrationService.getMappings().then((mappings) => {
      this.$scope.indicators.mappings = false;
      if (typeof mappings !== "string") {
        this.$scope.existingMappings = mappings;
      }
    });
  };

  private loadRoles = () => {
    this.$scope.indicators.roles = true;
    this.roleService.getRoles().then((roles) => {
      this.$scope.roles = roles.items;
      this.$scope.indicators.roles = false;
    });
  };

  private saveMappings = () => {
    this.$scope.indicators.saveMappings = true;

    const mappings = [];
    for (let i = 0; i < this.$scope.mappings.length; i++) {
      const mapping = {
        internalRole: this.$scope.mappings[i].internalRole.name,
        externalRole: this.$scope.mappings[i].externalRole,
      };

      mappings.push(mapping);
    }

    this.integrationService.updateADRoleMapping(mappings).then(
      () => {
        this.$scope.indicators.saveMappings = false;
        this.$state.go("^.done");
      },
      (error) => {
        console.error(error);
        this.$scope.indicators.saveMappings = false;
        this.$state.go("^.done");
      }
    );
  };

  private addMapping = () => {
    const newMapping = {
      internalRole: this.$scope.roles[0],
      externalRole: "adRoleName",
    };
    this.$scope.mappings.push(newMapping);
  };

  private deleteMapping = (index: number) => {
    this.$scope.existingMappings[index].deleting = true;
    this.integrationService.deleteMapping(this.$scope.existingMappings[index].id).then(() => {
      this.$scope.existingMappings.splice(index, 1);
    });
  };

  private removeMapping = (index: number) => {
    this.$scope.mappings.splice(index, 1);
  };
}
